<script setup lang="ts">
interface TestCard {
  type: string
  cardNumber: string
  cardExpiry: string
  cardCvc: string
  response: string
}
const testCards: TestCard[] = [
  {
    type: 'visa',
    cardNumber: '4111 1111 4555 1142',
    cardExpiry: '03/30',
    cardCvc: '737',
    response: 'Success',
  },
  {
    type: 'bancaire',
    cardNumber: '4035 5014 2814 6300',
    cardExpiry: '03/30',
    cardCvc: '737',
    response: '3D Secure',
  },
  {
    type: 'mastercard',
    cardNumber: '5454 5454 5454 5454',
    cardExpiry: '03/30',
    cardCvc: '737',
    response: '3D Secure',
  },
  {
    type: 'union pay',
    cardNumber: '6250 9470 0000 0014',
    cardExpiry: '03/30',
    cardCvc: '123',
    response: '3D Secure',
  },
  {
    type: 'amex',
    cardNumber: '3714 4963 5398 431',
    cardExpiry: '03/30',
    cardCvc: '7373',
    response: '3D Secure',
  },
  {
    type: 'mastercard',
    cardNumber: '5252 5202 0003 4065',
    cardExpiry: '12/29',
    cardCvc: '123',
    response: 'Insufficient funds',
  },
  {
    type: 'visa',
    cardNumber: '4970 1090 0325 6200',
    cardExpiry: '12/29',
    cardCvc: '123',
    response: 'Refused',
  },
]
</script>

<template>
  <div class="d-flex f-column mt-8">
    <div
      v-for="testCard in testCards"
      :key="testCard.cardNumber"
      style="font-size: small"
      class="d-flex ga-2 justify-space-between"
    >
      <div class="w-25">{{ testCard.type }}</div>
      <div class="w-33">{{ testCard.cardNumber }}</div>
      <div class="w-10">{{ testCard.cardExpiry }}</div>
      <div class="w-10">{{ testCard.cardCvc }}</div>
      <div class="w-25 ml-2">{{ testCard.response }}</div>
    </div>
  </div>
  <a
    class="mt-2"
    href="https://chromewebstore.google.com/detail/adyen-test-cards/icllkfleeahmemjgoibajcmeoehkeoag"
    >All Adyen Test Cards - Browser Extension</a
  >
</template>

<style scoped lang="scss"></style>
